import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ARApiError } from '@relayter/core';
import { catchError, map, Observable } from 'rxjs';
import { EGrantType } from '../../models/api/oauth-client.model';
import { OAuthTokenModel } from '../../models/api/oauth-token.model';
import { ApiConstants } from '../api.constant';
import { ApiPostRequest } from '../requests/api-post.request';
import { ApiService } from './api.service';

export type TokenRefreshError = ARApiError & { httpStatus: number };

@Injectable({ providedIn: 'root' })
export class OAuthApiService extends ApiService<OAuthTokenModel> {
    private readonly httpClient = inject(HttpClient);
    constructor() {
        super([ApiConstants.API_GROUP_OAUTH], OAuthTokenModel);
    }

    public tokenRefresh(): Observable<string> {
        // Request a new access token with a refresh token (stored in HttpOnly cookie)
        const request = new ApiPostRequest([...this.groups, ApiConstants.API_METHOD_TOKEN, ApiConstants.API_METHOD_REFRESH], OAuthTokenModel, {
            grant_type: EGrantType.REFRESH_TOKEN
        });
        return this.httpClient.post<any>(request.options.url, request.options.body).pipe(
            map((res) => res.access_token),
            catchError((error: unknown) => {
                const httpError = error instanceof HttpErrorResponse ? error : new HttpErrorResponse({ error });
                const apiError = Object.assign(ARApiError.fromHttpErrorResponse(httpError), {
                    httpStatus: httpError.status
                }) as TokenRefreshError;
                return new Observable<never>((observer) => observer.error(apiError));
            })
        );
    }
}
